import React, { useState } from "react";
import {
    Box,
    Tab,
    Tabs,
} from "@mui/material";
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import PatformAvailableLicense from "./PlatformAvailableLicense";
import PlatformImportLicense from "./PlatformImportLicense";




function PlatformLicense() {

    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event: any, newValue: any) => {
        setActiveTab(newValue);
    }



    return (
        <Box sx={{ display: 'flex' }}>
            <Box
                className="platformLicense"
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    marginTop: 0,
                    paddingTop: 0,
                }}
            >
                <TabContext value={activeTab.toString()}>
                    <Box sx={{ borderBottom: 1, borderColor: '#313838', }}>
                        <Tabs value={activeTab} onChange={handleTabChange} indicatorColor="primary"
                            textColor="inherit"
                            variant="fullWidth">
                            <Tab label="Available Licenses" value={0} style={{ textTransform: "none" }} />
                            <Tab label="Import Licenses" value={1} style={{ textTransform: "none" }} />
                        </Tabs>
                    </Box>
                    <TabPanel value="0" sx={{ padding: "35px 0px 0px 0px" }}>
                        <PatformAvailableLicense />
                    </TabPanel>
                    <TabPanel value="1" sx={{ padding: "15px 0px 0px 0px" }}>
                        <PlatformImportLicense />
                    </TabPanel>
                </TabContext>
            </Box>
        </Box>
    )
}

export default PlatformLicense